$(function () {
  $(document).on('mouseenter', '.grid-swatch:not(.product-swatch) .grid-product__colors .color-swatch', function (e) {
    var img = $(this).data('img');
    var id = $(this).data('var-id');
    var is_avail = $(this).attr('data-available');
    $(this).closest('.grid-swatch-left').find('.grid-product__colors span').removeClass('selected');
    $(this).addClass('selected');
    if (is_avail == 'false') {
      $(this).closest('.product-bottom').find('.add-to-cart-grid').addClass('ctm_sold-out');
      $(this).closest('.product-bottom').find('.add-to-cart-grid').text('Sold Out');
    } else {
      $(this).closest('.product-bottom').find('.add-to-cart-grid').removeClass('ctm_sold-out');
      $(this).closest('.product-bottom').find('.add-to-cart-grid').text('Add to Cart');
    }
    if (img != '' && img != undefined && img != null) {
      $(this).closest('.card-wrapper').find('.card__media img').attr('srcset', img);
    }
    $(this).closest('.card-wrapper').find('.quick-add form [name="id"]').val(id);
  })

  $(document).on('click', '.grid-product__colors .color-swatch', function (e) {
    var url = $(this).data('url');
    window.location.href = url;
  })

  $(document).on('click', '.add-to-cart-grid', function (e) {
    $(this).closest('.card-wrapper').find('form [type="submit"]').trigger('click');
  })
  // $('.grid-swatch.product-swatch .grid-product__colors .color-swatch.selected').trigger('click');
});



$(".filter-click-top").click(function () {
  $("body").toggleClass("filter-open");
});


$(".mobile-brand-filter").click(function () {
  $("body").addClass("brand_open");
});

$(".icon-close-brand, .overlay-brand").click(function () {
  $("body").removeClass("brand_open");
})

if ($(".mobile-product-slider .swiper").length > 0) {
  window.slider = new Swiper(".mobile-product-slider .swiper", {
    direction: "vertical",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    mousewheel: true,
    autoHeight: true,
    observer: true,
    updateOnWindowResize: true,
    // observer: true,
    runCallbacksOnInit: true,
    updateOnImagesReady: true
    // observeSlideChildren: true,    
  });
  var id = $('.ctm_colors.ctm_checked').data('id');
  var index = $('.mobile-product-slider .product-slider-item[data-media-id="' + id + '"]').data('index');
  window.slider.slideTo(index);
}

// window.slider.on('wheel', (function(e) {
//   e.preventDefault();
//   console.log('working..');
//   if (e.originalEvent.deltaY < 0) {

//   } else {

//   }
// }));




function getHandlized(str) {
  if (!str) return '';
  return str.toString().toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
}

function update_product_media_filter() {
  var inputs = $('.product-form__input');
  if (inputs.length === 0) return;

  var opt1Input = inputs.eq(0).find('input[type="radio"]:checked, select');
  var opt1Name = opt1Input.attr('name') || '';
  if (opt1Name.indexOf('options[') > -1) opt1Name = opt1Name.replace('options[', '').replace(']', '');
  if (!opt1Name) opt1Name = inputs.eq(0).find('legend').clone().children().remove().end().text().trim();
  var opt1Val = opt1Input.val() || '';

  var opt2Input = inputs.eq(1).find('input[type="radio"]:checked, select');
  var opt2Name = opt2Input.length > 0 ? (opt2Input.attr('name') || '') : '';
  if (opt2Name.indexOf('options[') > -1) opt2Name = opt2Name.replace('options[', '').replace(']', '');
  if (!opt2Name && inputs.length > 1) opt2Name = inputs.eq(1).find('legend').clone().children().remove().end().text().trim();
  var opt2Val = opt2Input.length > 0 ? opt2Input.val() : '';

  // Update the label text with the selected value for EVERY option group
  inputs.each(function () {
    var $fieldset = $(this);
    var selectedVal = $fieldset.find('input[type="radio"]:checked, select').val();

    if (selectedVal) {
      // Find the legend or label for this specific option group
      var $legend = $fieldset.find('legend, .form__label').first();
      if ($legend.length > 0) {
        $legend.find('.ctm_color_name').remove();
        $legend.append('<span class="ctm_color_name"> ' + selectedVal + '</span>');
      }
    }
  });

  var targetCombined = opt2Val ? (opt1Name + ": " + opt1Val + " + " + opt2Name + ": " + opt2Val) : "";
  var targetOpt1Only = opt1Name + ": " + opt1Val;

  var handleCombined = targetCombined ? getHandlized(targetCombined) : "";
  var handleOpt1Only = getHandlized(targetOpt1Only);

  var selectedOptions = [];
  inputs.each(function () {
    var val = $(this).find('input[type="radio"]:checked, select').val();
    if (val) selectedOptions.push(getHandlized(val));
  });

  var handleOpt1ValOnly = selectedOptions[0] || '';
  var handleOpt2ValOnly = selectedOptions[1] || '';




  var $allDesktop = $('.product__media-list .product__media-item');
  var $allMobile = $('.mobile-product-slider .product-slider-item');

  var exactDesktop = [];
  var exactMobile = [];
  var opt1Desktop = [];
  var opt1Mobile = [];

  function checkMatch($el, pushExactArr, pushOpt1Arr) {
    var activeOptions = selectedOptions.filter(function (opt) { return opt !== ''; });
    var totalSelected = activeOptions.length;


    $el.each(function () {
      var altTag = $(this).attr('data-alt') || '';
      // Also check the nested image alt as it often contains the full || string
      var imgAlt = $(this).find('img').attr('alt') || '';
      if (imgAlt.indexOf('||') > -1) altTag = imgAlt;
      
      // BW-052: exact pipe-tagged colors for these two Baggu products only.
      // Untagged/shared media and the existing no-match fallback stay unchanged.
      if (/\/products\/baggu-(small-nylon-bowler|everyday-cloud)-bag\/?$/.test(window.location.pathname)) {
        var bagguAlt = imgAlt || altTag;
        var bagguParts = bagguAlt.split('|');
        var bagguColor = getHandlized(bagguParts[bagguParts.length - 1]);
        if (bagguAlt.indexOf('||') === -1 && bagguParts.length > 1 && bagguColor) {
          if (bagguColor === handleOpt1ValOnly) pushOpt1Arr.push(this);
          return;
        }
      }

      var handlizedAlt = getHandlized(altTag);
      var isCombo = altTag.indexOf('||') > -1;
      if (isCombo) {
        // COMBO LOGIC: Only look at the part after ||
        var filterPart = getHandlized(altTag.split('||')[1]);
        
        var matchedCount = 0;
        activeOptions.forEach(function (opt) {
          if (filterPart.indexOf(opt) > -1) {
            matchedCount++;
          }
        });



        if (totalSelected > 1 && matchedCount === totalSelected) {
          pushExactArr.push(this);
        } else if (matchedCount > 0) {
          pushOpt1Arr.push(this);
        }
      } else {
        // REGULAR LOGIC: Check if the alt tag contains ANY of the selected values
        var regularMatchCount = 0;
        activeOptions.forEach(function (opt) {
          if (handlizedAlt.indexOf(opt) > -1) {
            regularMatchCount++;
          }
        });

        var isMatch = regularMatchCount > 0;

        
        if (isMatch) {
          pushOpt1Arr.push(this);
        }
      }
    });
  }

  checkMatch($allDesktop, exactDesktop, opt1Desktop);
  checkMatch($allMobile, exactMobile, opt1Mobile);



  var $visibleSlidesMobile;

  $allDesktop.hide();
  $allMobile.hide();

  // 1. Prioritize PERFECT matches (Match 2/2)
  if (exactDesktop.length > 0 || exactMobile.length > 0) {

    $(exactDesktop).show();
    $(exactMobile).show();
    $visibleSlidesMobile = $(exactMobile);
  }
  // 2. Fallback to single matches (Match 1/2) if no perfect matches exist
  else if (opt1Desktop.length > 0 || opt1Mobile.length > 0) {

    $(opt1Desktop).show();
    $(opt1Mobile).show();
    $visibleSlidesMobile = $(opt1Mobile);
  } else {
    // Fallback: strictly match the original code's behavior (show elements with [data-alt])
    var fallbackDesktop = $('.product__media-list .product__media-item[data-alt]');
    var fallbackMobile = $('.mobile-product-slider .product-slider-item[data-alt]');
    fallbackDesktop.show();
    fallbackMobile.show();
    $visibleSlidesMobile = fallbackMobile;
  }

  // Original working Swiper update logic
  setTimeout(function (e) {
    // This marker is emitted only for product 10476277104947.
    // Keep its assigned-media selection when no slides were filtered out.
    if (window.slider && window.slider.slideTo &&
        !(document.querySelector('.mobile-product-slider.bw-hightide-mobile-frame') &&
          $visibleSlidesMobile && $visibleSlidesMobile.length === $allMobile.length)) {
      window.slider.slideTo(0);
    }
  }, 50);

  if (window.slider) {
    window.slider.updateSize();
    window.slider.updateSlides();
    window.slider.updateProgress();
    window.slider.updateSlidesClasses();
    if (window.slider.scrollbar) {
      window.slider.scrollbar.updateSize();
    }
  }

  if ($visibleSlidesMobile && $visibleSlidesMobile.length > 0) {
    var height = $visibleSlidesMobile.eq(0).find('.product-slider-item-inner').height();
    if (height) {
      $('.mobile-product-slider .mySwiper .swiper-wrapper').css('min-height', height + 'px');
    }
  }
}

$(document).on('change', '.product-form__input input[type="radio"], .product-form__input select', function (e) {
  update_product_media_filter();
});

// Remove the old initializers since we are replacing them
// init_first_time_slider(); 

// JavaScript Document	
$(document).ready(function (e) {
  // Show the first tab by default
  $('.tabs-stage .tabcontent').hide();
  $('.tabs-stage .tabcontent:first').show();
  $('.tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.tabs-nav a').on('click', function (event) {
    event.preventDefault();
    $('.tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .tabcontent').hide();
    $($(this).attr('href')).show();
  });
  update_product_media_filter(); // Run on document ready
});

$(window).on('load', function (e) {
  update_product_media_filter(); // Run on window load
});


$('.menu-popular-search li a').on('click', function (e) {
  e.preventDefault();
  var searchText = $(this).text()
  var searchInput = document.querySelector('.header__search-mobile predictive-search')?.input;
  if (searchInput) {
    searchInput.value = searchText;
    searchInput.dispatchEvent(new Event('input'))
  }
})

if ($('.brand-section-right .brand-tab-content').length > 0) {
  var url = window.location.href;
  if (url.indexOf('#') > -1) {
    var splt_text = url.split('#')[1];
    $('html, body').animate({
      scrollTop: $(".mobile-brand-filter").offset().top - 120
    }, 1000);
    $('.brand-section-right .brand-tab-content').hide()
    $('.brand-section-right .brand-tab-content[id="' + splt_text + '"]').show();
  }
}


$(".filter_search_inline").click(function () {
  $(".main-blog-filter-search").addClass("open_search");
});

$(".filter_close_inline").click(function () {
  $(".main-blog-filter-search").removeClass("open_search");
});


var swiper = new Swiper('.search-slider', {
  slidesPerView: '1',
  spaceBetween: 0,
  autoHeight: true,
  loop: false,
  grabCursor: true,
  observer: true,
  freeMode: false,
  observeParents: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: true,
    draggable: true,
  },
  keyboard: {
    enabled: true,
  },
});


AOS.init();










